import { Container, LinearProgress, Stack } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { CasUserContext, useCasUserContext } from "../../services/casUserContext";
import AlertService from "../../services/AlertService";
import { GeneralPowerBIComp } from "../../componentes/Dashboard/GeneralPowerBIComp";
import UsuarioService from "../../services/UsuarioService";

const alertaService = new AlertService();
const usuarioService = new UsuarioService();

export const ProyectosInvestigacionPage: React.FC<{}> = () => {
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const userData = casUserContext.userData;
    let [ready, setReady] = useState(false);
    let [auth, setAuth] = useState(true);
    const AUTORIZADOS = [142, 143, 144,145,150,156];
    const ruta = 'https://app.powerbi.com/reportEmbed?reportId=ae46ada5-4c05-45d6-b7e7-46c3c103a7b4&autoAuth=true&ctid=b7af8caf-83d8-4644-85ae-317c545223c1'

    //#region Seccion Funciones
    const fetchData = async () => {
        try {
            alertaService.showLoading("Cargando...");
            let flat = usuarioService.authorizedByGroup(AUTORIZADOS, userData.roles);
            setTimeout(() => {
                setReady(true);
            }, 3000);
            setAuth(flat);
            alertaService.hideLoading();
        } catch (error) {
            console.error('Error:', error);
            alertaService.hideLoading();
            alertaService.alertaAdvertencia('Error', 'Ocurrio un error al momento de cargar la información.');
        }
    };

    //#endregion
    //#region Seccion Carga
    useEffect(() => {
        fetchData();
    }, [userData]);
    //#endregion

    return (
        <Container sx={{ mt: 2 }}>
            <>
                {ready ?
                    <GeneralPowerBIComp urlDashboard={ruta} titulo={"Proyectos Investigación"} autorizado={auth} usuario={userData.netId} nombres={userData.nombres} apellidos={userData.apellidos} />
                    :
                    <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                        <LinearProgress color="secondary" />
                    </Stack>
                }
            </>
        </Container>
    )
}